<div class="animated fadeIn">
    <app-create-guide-service
        [guideServiceDetails]="guideServiceDetails"
        [tours]="tours"
        [guides]="guides"
        [events]="events"
        (guideServicesNavigation)="onGuideServicesNavigation()"
        (guideServicesUpdated)="onGuideServicesUpdated($event)"
        (guideSelected)="onGuideSelected($event)"
        (tourAndDateSelected)="onTourAndDateSelected($event)"
    ></app-create-guide-service>
</div>


<app-message-panel></app-message-panel>